import * as React from 'react';
import { Box, Button, Container, SvgIcon, Typography } from '@mui/material';
import { t } from 'i18next';

const NotFound = () => (
  <>
   
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        minHeight: '100%'
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              mb: 3,
              textAlign: 'center'
            }}
          >
            <img
              alt="Under development"
              src="/public/images/error-404.png"
              style={{
                display: 'inline-block',
                maxWidth: '100%',
                width: 400
              }}
            />
          </Box>
          <Typography
            align="center"
            sx={{ mb: 3 }}
            variant="h3"
          >
            {t("notFound.fourZeroFour")}
          </Typography>
          <Typography
            align="center"
            color="text.secondary"
            variant="body1"
          >
            {t("notFound.helpMsg")}
          </Typography>
          <Button
            
            href="/"
            startIcon={(
              <SvgIcon fontSize="small">
                
              </SvgIcon>
            )}
            sx={{ mt: 3 }}
            variant="contained"
          >
            {t("notFound.goBackToStart")}
          </Button>
        </Box>
      </Container>
    </Box>
  </>
);

export default NotFound;